// Copyright (c) 2018 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateAmountOfUseModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_NEW_TRANSFER_AMOUNT_OF_USE_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/amount-of-use-modal-visibility.js